import React, { useEffect, useContext} from 'react'
import {Card, CardHeader, CardContent, CardActions, Typography, Button, Table, TableRow, TableCell, TableBody} from '@mui/material'
import Box from '@mui/material/Box';
import Axios from 'axios'
import {useHelper} from '../hooks/useHelper'
import { ETNuevaInscripcion } from './ETNuevaInscripcion';
import {v4 as uuidv4} from 'uuid';
import { formularioContext } from '../contextos/FormularioContext'
import { useNavigate } from 'react-router-dom';
import {ETDetalleProducto} from './ETDetalleProducto'

export const ETPrecios = ({id_evento,target,selectItem,evento})=>{
    const [productos,setProductos] = React.useState([])
    const {formatearMontoMoneda}= useHelper()
    const [idEvValorSeleccionado,setIdEvValorSeleccionado] = React.useState(null)
    const {validarMinistroEventoSeleccionado,
} = useContext(formularioContext)
    const {hacerScroll} = useHelper();
    const navigate = useNavigate();

    const buscarEventosValor = async (id_evento,setEnSeleccion)=>{
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/tablasgenerales/eventosvalor/${id_evento}`:`https://uadapi.uad.digital/api/tablasgenerales/eventosvalor/${id_evento}`)

            let dataTargeted = [];

            switch(target){
                case 'uad': dataTargeted = data.filter(i=>i.tipo_persona!='externo'); break // incluye tipo_persona = todos + uad
                case 'ex': dataTargeted = data.filter(i=>i.tipo_persona!='uad'); break // incluye tipo_persona = todos + externo
                case 'all': dataTargeted = data; break // incluye tipo_persona = todos + externo + uad
                default :
                    dataTargeted=[];console.log('El parámetro target no está tipificado','Eventos = []') 
            }

            let dataOrdered = [];
            const uad = dataTargeted.filter(i=>i.tipo_persona=='uad');
            const externos = dataTargeted.filter(i=>i.tipo_persona=='externo');
            const todos = dataTargeted.filter(i=>i.tipo_persona=='todos');

            dataOrdered=[...uad,...externos,...todos]

            setProductos(dataOrdered)
        }catch(err){
            console.log(err)
        }
    }

    useEffect(()=>{
        if(id_evento){
            buscarEventosValor(id_evento)
        }
    },[id_evento,target])

    const seleccionarEvValor = async (idEventoValor)=>{

        selectItem(idEventoValor)
    }
    
    return <Box sx={{padding:'0.5rem',maxWidth:'500px',display:'flex',flexDirection:'column'}}>
    <Typography id='it-select' style={{margin:'1rem',textAlign:'left'}} variant="h5"> {idEvValorSeleccionado ? 'Tipo de inscripción seleccionada:':' Opciones de inscripción:'}</Typography>
    <Table style={{background:''}}>
        <TableBody>
            {productos.filter((producto)=>producto.activo && (!idEvValorSeleccionado || idEvValorSeleccionado?.id_evento_valor == producto.id_evento_valor)).map((item, index,array) => (
                // <ETDetalleProducto navigate={navigate} listIndex={index+1} item={item} idEvValorSeleccionado={idEvValorSeleccionado} setIdSeleccionado={seleccionarEvValor} hayOtrosItems={true}/>
                <ETDetalleProducto siBorder={siBorder(item,index,array)} target={target} item={item} setIdSeleccionado={seleccionarEvValor}/>
            ))}
        </TableBody>
    </Table>
    {idEvValorSeleccionado && <>
        {validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[0] && <ETNuevaInscripcion id_evento={id_evento}  eventoValorSeleccionado={idEvValorSeleccionado}/>}
        {!validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[0] && <p>{validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[1]}</p>}
    </>}        
  </Box>
}

const siBorder = (item,index,array)=>{

    const tipoActual = item.tipo_persona;
    const tipoSiguiente = index < array.length -1  ? array[index+1].tipo_persona : tipoActual;

    if (tipoActual!=tipoSiguiente){
        return true
    }

    return false
}